import React from "react";
import MatchedAdRow from "./MatchedAdRow";
import AddMatchDropdown from "./AddMatchDropdown";

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  });
};

const EventMatchDetail = ({
  event,
  matches,
  loading,
  teamId,
  onRemoveMatch,
  onCreateMatch,
}) => {
  if (!event) {
    return (
      <div className="meta-social-ads__detail">
        <div className="meta-social-ads__detail-empty">
          Select an event to view matched ads
        </div>
      </div>
    );
  }

  return (
    <div className="meta-social-ads__detail">
      <div className="meta-social-ads__detail-header">
        <h2 className="meta-social-ads__detail-title">{event.title}</h2>
        <div className="meta-social-ads__detail-date">
          {formatDate(event.eventDate)}
          {event.venueName ? ` \u00B7 ${event.venueName}` : ""}
        </div>
      </div>

      <div className="meta-social-ads__matches-section">
        <div className="meta-social-ads__section-title">
          Matched Ads ({matches.length})
        </div>

        {loading ? (
          <div className="meta-social-ads__loading">Loading matches...</div>
        ) : matches.length > 0 ? (
          matches.map((match) => (
            <MatchedAdRow key={match.id} match={match} onRemove={onRemoveMatch} />
          ))
        ) : (
          <div className="meta-social-ads__no-matches">
            No ads matched to this event yet
          </div>
        )}
      </div>

      <div className="meta-social-ads__section-title">Add Match</div>
      <AddMatchDropdown
        teamId={teamId}
        eventId={event.id}
        onAdd={onCreateMatch}
      />
    </div>
  );
};

export default EventMatchDetail;
